/*
 * @Description: axios拦截器
 * @Author: wsl
 * @Date: 2022-06-09 20:30:38
 * @LastEditors: 陈威达
 * @LastEditTime: 2024-01-17 09:42:32
 */
import axios from 'axios'
import { notification, message } from 'antd'
import { SYSCON } from '@/const/const'
import gerlunLib from 'gerlun-lib'

const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  302: '请求重定向',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}

const handleRedirect = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL
  const url = baseUrl + '/mtce/index.html'
  window.location.href = url
}

/** 异常处理程序 */

const errorHandler = (error) => {
  let status = 0
  let cd = ''
  if (error.response) {
    status = error.response.status
    cd = error.response.data.cd
  } else if (error.status) {
    status = error.status
    cd = error.cd
  }
  console.log('cd', cd)
  if (cd === 302) {
    handleRedirect()
  }
  if (status) {
    const errorText = codeMessage[status]
    if (cd === 4010001 && status === 401) {
      message.warning('您还未登录')
      localStorage.removeItem(SYSCON.Token)
      var timer = setInterval(() => {
        window.location.reload() // 强制刷新页面
      }, 1000)
      clearImmediate(timer)
      return
    }
    notification.error({
      message: `请求错误 ${status}`,
      description: errorText
    })
  } else if (!status) {
    notification.error({
      description: '您的网络发生异常，无法连接服务器',
      message: '网络异常'
    })
  }

  if (error.message.indexOf('timeout') !== -1) {
    error.message = '接口请求超时'
  }
  return Promise.reject(error)
}

// axios 配置
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.common['appCatCd'] = SYSCON.PlatAppWorkbench
axios.defaults.headers.common['Token'] = localStorage.getItem(SYSCON.Token) || ''
axios.defaults.headers.common['content-type'] = 'application/json;charset=UTF-8'

// 超时配置
axios.defaults.timeout = 30000

// Add a request interceptor
axios.interceptors.request.use(function(config) {
  // 在url增加前端请求标识 story-1894
  config.url = config.url + (config.url.indexOf('?') === -1 ? '?' : '&') + '_wn=' + new Date().getTime()
  config.headers.Token = localStorage.getItem(SYSCON.Token)
  gerlunLib.reqSign(config)
  return config
}, function(error) {
  return Promise.reject(error)
})

// Add a response interceptor
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  // 错误处理
  return errorHandler(error)
})

